export const textMaxLength = {
    galleryText: 70,
    galleryTitle: 30,
    subLinks: 45,
    movieText: 200,
    lessonTitle: 50,
    docName: 15,
    movieGallery: 50
}
